import { LayaGL } from "../layagl/LayaGL";
import { BufferUsage } from "../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../RenderEngine/RenderEnum/IndexFormat";
import { MeshTopology } from "../RenderEngine/RenderEnum/RenderPologyMode";
import { VertexMesh } from "../RenderEngine/RenderShader/VertexMesh";
export class LoadModel2DV01 {
    static parse(readData, version, mesh, subMeshes) {
        LoadModel2DV01._mesh = mesh;
        LoadModel2DV01._subMeshes = subMeshes;
        LoadModel2DV01._version = version;
        LoadModel2DV01._readData = readData;
        LoadModel2DV01.READ_DATA();
        LoadModel2DV01.READ_BLOCK();
        LoadModel2DV01.READ_STRINGS();
        for (var i = 0, n = LoadModel2DV01._BLOCK.count; i < n; i++) {
            LoadModel2DV01._readData.pos = LoadModel2DV01._BLOCK.blockStarts[i];
            var index = LoadModel2DV01._readData.readUint16();
            var blockName = LoadModel2DV01._strings[index];
            var fn = LoadModel2DV01["READ_" + blockName];
            if (fn == null)
                console.warn("model file err,no this function:" + index + " " + blockName);
            else
                fn.call(null);
        }
        LoadModel2DV01._strings.length = 0;
        LoadModel2DV01._readData = null;
        LoadModel2DV01._version = null;
        LoadModel2DV01._mesh = null;
        LoadModel2DV01._subMeshes = null;
    }
    static _readString() {
        return LoadModel2DV01._strings[LoadModel2DV01._readData.readUint16()];
    }
    static READ_DATA() {
        LoadModel2DV01._DATA.offset = LoadModel2DV01._readData.readUint32();
        LoadModel2DV01._DATA.size = LoadModel2DV01._readData.readUint32();
    }
    static READ_BLOCK() {
        var count = LoadModel2DV01._BLOCK.count = LoadModel2DV01._readData.readUint16();
        var blockStarts = LoadModel2DV01._BLOCK.blockStarts = [];
        var blockLengths = LoadModel2DV01._BLOCK.blockLengths = [];
        for (var i = 0; i < count; i++) {
            blockStarts.push(LoadModel2DV01._readData.readUint32());
            blockLengths.push(LoadModel2DV01._readData.readUint32());
        }
    }
    static READ_STRINGS() {
        var offset = LoadModel2DV01._readData.readUint32();
        var count = LoadModel2DV01._readData.readUint16();
        var prePos = LoadModel2DV01._readData.pos;
        LoadModel2DV01._readData.pos = offset + LoadModel2DV01._DATA.offset;
        for (var i = 0; i < count; i++)
            LoadModel2DV01._strings[i] = LoadModel2DV01._readData.readUTFString();
        LoadModel2DV01._readData.pos = prePos;
    }
    static READ_MESH() {
        var i;
        var memorySize = 0;
        var name = LoadModel2DV01._readString();
        var reader = LoadModel2DV01._readData;
        var arrayBuffer = reader.rawBuffer;
        var vertexBufferCount = reader.readInt16();
        var offset = LoadModel2DV01._DATA.offset;
        var mesh = LoadModel2DV01._mesh;
        let vertexBuffers = [];
        var vertexCount = 0;
        let vertices = [];
        for (i = 0; i < vertexBufferCount; i++) {
            var vbStart = offset + reader.readUint32();
            var byteLength = reader.readUint32();
            var vertexFlag = LoadModel2DV01._readString();
            var vertexDeclaration = VertexMesh.getVertexDeclaration(vertexFlag, false);
            var vertexData = arrayBuffer.slice(vbStart, vbStart + byteLength);
            vertices[i] = vertexData;
            var vertexBuffer = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Static);
            vertexBuffer.vertexDeclaration = vertexDeclaration;
            vertexBuffer.setDataLength(byteLength);
            vertexBuffer.setData(vertexData, 0, 0, byteLength);
            vertexCount = byteLength / vertexDeclaration.vertexStride;
            memorySize += byteLength;
            vertexBuffers[i] = vertexBuffer;
        }
        if (vertexCount > 65535)
            mesh._indexFormat = IndexFormat.UInt32;
        else
            mesh._indexFormat = IndexFormat.UInt16;
        var ibStart = offset + reader.readUint32();
        var ibLength = reader.readUint32();
        var ibDatas, byteCount;
        if (mesh.indexFormat == IndexFormat.UInt32) {
            ibDatas = new Uint32Array(arrayBuffer.slice(ibStart, ibStart + ibLength));
            byteCount = 4;
        }
        else {
            ibDatas = new Uint16Array(arrayBuffer.slice(ibStart, ibStart + ibLength));
            byteCount = 2;
        }
        var indexBuffer = LayaGL.renderDeviceFactory.createIndexBuffer(BufferUsage.Static);
        indexBuffer.indexType = mesh.indexFormat;
        indexBuffer.indexCount = ibLength / byteCount;
        indexBuffer._setIndexDataLength(ibLength);
        indexBuffer._setIndexData(ibDatas, 0);
        mesh._setBuffers(vertexBuffers, indexBuffer);
        mesh.canRead = true;
        mesh._vertices = vertices;
        mesh._indices = ibDatas;
        memorySize += ibDatas.byteLength;
        mesh._setCPUMemory(memorySize);
        mesh._setGPUMemory(memorySize);
        mesh.name = name;
        return true;
    }
    static READ_SUBMESH() {
        var reader = LoadModel2DV01._readData;
        var subMesh = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.Triangles, DrawType.DrawElement);
        reader.readInt16();
        let mesh = LoadModel2DV01._mesh;
        subMesh.bufferState = mesh._bufferState;
        subMesh.indexFormat = mesh.indexFormat;
        var drawCount = reader.readUint16();
        for (var i = 0; i < drawCount; i++) {
            let ibOffset = reader.readUint32();
            let ibCount = reader.readUint32();
            subMesh.setDrawElemenParams(ibCount, ibOffset);
        }
        LoadModel2DV01._subMeshes.push(subMesh);
        return true;
    }
}
LoadModel2DV01._BLOCK = { count: 0 };
LoadModel2DV01._DATA = { offset: 0, size: 0 };
LoadModel2DV01._strings = [];
